import { render } from "./Home.vue?vue&type=template&id=0a8e45dc"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script